import { render } from "./SidebarItem.vue?vue&type=template&id=439ad643"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=439ad643&lang=css"
script.render = render

export default script